<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-26 16:42:17
 * @LastEditors: jing
 * @LastEditTime: 2020-12-09 14:52:40
 * @Description: 
 只在测试环境展示
 -->
<template>
  <div class="mine" v-if="userInfo">
    <!-- 用户信息区 开始 -->
    <div class="ui">
      <div class="ui_left">
        <div class="ui_headline">
          <img v-bind:src="userInfo.user.headimgurl" />
        </div>
      </div>
      <div class="ui_right">
        <!-- 没有提交注册 -->
        <div
          class="no_reg"
          v-if="isShowNoSaleNoAgentMenuItems && isShowRegister"
        >
          <div class="ui_name">
            {{ userInfo.user.name || userInfo.user.nickname }}
          </div>
          <!-- 注册审核状态 注册后为岗位信息 -->
          <div class="ui_apply_status" v-if="registerStatusMsg">
            {{ registerStatusMsg }}
          </div>
        </div>
        <!-- 注册提交了 -->
        <div class="reg" v-else>
          <div class="ui_name">
            {{ userInfo.user.name || userInfo.user.nickname }}
          </div>
          <!-- 注册审核状态 注册后为岗位信息 -->
          <div class="ui_apply_status" v-if="registerStatusMsg">
            {{ registerStatusMsg }}
          </div>
          <div class="ui_op" v-if="userIntegralInfo && userIntegralInfo.isSale">
            <img
              @click="clickInfo"
              src="https://assets.rurushishi.com/yq-rs-make/t9_my/icon_info.png"
              alt
            />
            <img
              @click="clickModify"
              src="https://assets.rurushishi.com/yq-rs-make/t9_my/icon_modify.png"
              alt
            />
          </div>
        </div>
        <!-- 放置个显眼的全民经纪人注册 -->
        <div
          v-if="isShowRegister && isShowRegisterAgent"
          class="ui_reg_agent"
          @click="clickRegisterAgent"
        >
          全民经纪人注册
        </div>
      </div>
    </div>
    <!-- 用户信息区 结束 -->

    <!-- 未注册区域 开始 -->
    <div class="layer1" v-if="isShowRegister && isShowNoSaleNoAgentMenuItems">
      <div class="area_title">
        <span>我的服务</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in noSaleNoAgentMenuItems"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>

      <!-- 直接注册中介区域 -->
      <div
        v-if="isShowRegister && isShowRegisterAgent && registerType == 'agent'"
      >
        <div class="cut_line"></div>
        <!-- 我要推荐 H5环境下 -->
        <img
          v-if="!isInMiniProgram && isShowMyRecommend"
          style="width: 100%"
          :src="myRecommendPosterUrl"
          alt
        />
        <!-- 我要推荐 小程序环境下 -->
        <div
          class="btn1"
          v-if="isInMiniProgram && isShowMyRecommend && isShowGuide"
          @click="clickGetMyRecommendPosterInMp"
        >
          领取合伙人二维码
        </div>
        <RegisterHr v-on:afterRegisterHr="afterRegisterHr"></RegisterHr>
      </div>
      <div v-if="isShowRegister && registerType == 'sale'">
        <div class="cut_line"></div>
        <RegisterVipcard
          v-on:afterRegisterVipcard="afterRegisterVipcard"
        ></RegisterVipcard>
      </div>
    </div>
    <!-- 未注册区域 结束 -->

    <!-- 销售-置业顾问 开始 -->
    <div class="layer1" v-if="isShowSale2011MenuItems">
      <div class="area_title">
        <span>我的服务</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in sale2011MenuItems.service"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="cut_line"></div>
      <div class="area_title">
        <span>推广拓客</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in sale2011MenuItems.toker"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="cut_line"></div>
      <div class="area_title">
        <span>客户管理</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in sale2011MenuItems.manage"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 销售-置业顾问 结束 -->

    <!-- 销售-案场管理员 开始 -->
    <div class="layer1" v-if="isShowSale2015MenuItems">
      <div class="area_title">
        <span>我的服务</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in sale2015MenuItems.service"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="cut_line"></div>
      <div class="area_title">
        <span>推广拓客</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in sale2015MenuItems.toker"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="cut_line"></div>
      <div class="area_title">
        <span>客户管理</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in sale2015MenuItems.manage"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 销售-案场管理员 结束 -->

    <!-- 中介 开始 -->
    <div class="layer1" v-if="isShowAgentMenuItems">
      <div class="area_title">
        <span>我的服务</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in agentMenuItems.service"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="cut_line"></div>
      <div class="area_title">
        <span>推广拓客</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in agentMenuItems.toker"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div class="cut_line"></div>
      <div class="area_title">
        <span>客户管理</span>
      </div>
      <div class="menu">
        <div
          class="menu_item"
          v-for="item in agentMenuItems.manage"
          @click="clickMenu(item)"
        >
          <img :src="item.icon" />
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 中介 结束 -->
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";

import { MessageBox, Toast } from "mint-ui";

const RegisterHr = () => import("@/components/register-hr");
const RegisterVipcard = () => import("@/components/register-vipcard");
import Cookies from "js-cookie";
import Canvastoimg from "wtc-canvastoimg";
import upload from "@/utils/upload";
export default {
  components: {
    RegisterHr,
    RegisterVipcard
  },
  props: {},
  data() {
    return {
      // 普通用户菜单
      noSaleNoAgentMenuItems: [
        {
          icon:
            "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodeliulan.png",
          name: "我的浏览",
          type: "link",
          repository: "shqc-web",
          value: "rs-fmarket-share.html"
        },
        {
          icon:
            "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodexiaoxi.png",
          name: "我的消息",
          type: "link",
          repository: "shqc-web",
          value: "rs-fmarket-notice.html"
        },
        {
          icon:
            "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodedingdan.png",
          name: "我的订单",
          type: "link",
          repository: "yq-act-web",
          value: ""
        },
        {
          icon:
            "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_woderenchou.png",
          name: "我的认筹",
          type: "link",
          repository: "shqc-act&branch=wjAct&dir=onlinerecognition",
          value: "orderHouseList"
        },
        {
          icon:
            "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_yijianfankui.png",
          name: "意见反馈",
          type: "methods",
          repository: "",
          value: "clickYjfk"
        },
        {
          icon:
            "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_xiaoshouzhuce.png",
          name: "销售注册",
          type: "methods",
          repository: "",
          value: "clickRegisterSale"
        }
      ],
      // 是否展示普通用户菜单
      isShowNoSaleNoAgentMenuItems: false,
      // 是否展示直接注册区域和显眼的注册按钮
      isShowRegister: false,
      // 是否展示头部全民经纪人注册
      isShowRegisterAgent: true,
      // 注册类型
      registerType: "agent",
      // 注册状态
      registerStatusMsg: "",
      // 销售 菜单
      sale2011MenuItems: {
        service: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodedingdan.png",
            name: "我的订单",
            type: "link",
            repository: "yq-act-web",
            value: ""
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_woderenchou.png",
            name: "我的认筹",
            type: "link",
            repository: "shqc-act&branch=wjAct&dir=onlinerecognition",
            value: "orderHouseList"
          }
        ],
        toker: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_huokeneirong.png",
            name: "获客内容",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-share.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_xiaoshouxiansuo.png",
            name: "销售线索",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-track.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_fensishouzhong.png",
            name: "粉丝受众",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-fans.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_xiaoxitongzhi.png",
            name: "消息通知",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-notice.html"
          },
          {
            icon: "http://assets.rurushishi.com/yq-rs-desk/icon-live.png",
            name: "直播",
            type: "link",
            repository: "yq-rs-make",
            value: "live/myliveroom"
          }
        ],
        manage: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_tianjiakehu.png",
            name: "添加客户",
            type: "link",
            repository: "shqc-web",
            value: "personal-info-cqrc-project.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodekehu.png",
            name: "我的客户",
            type: "link",
            repository: "shqc-web",
            value: "customer-list-hr.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_yufenpei.png",
            name: "预分配",
            type: "link",
            repository: "shqc-web",
            value: "user-pre-allot.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_zaixianrenchou.png",
            name: "在线认筹",
            type: "link",
            repository: "shqc-act&branch=wjAct&dir=onlinerecognition",
            value: "salePage"
          }
        ]
      },
      // 是否展示销售员菜单
      isShowSale2011MenuItems: false,
      // 案场管理员 菜单
      sale2015MenuItems: {
        service: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodedingdan.png",
            name: "我的订单",
            type: "link",
            repository: "yq-act-web",
            value: ""
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_woderenchou.png",
            name: "我的认筹",
            type: "link",
            repository: "shqc-act&branch=wjAct&dir=onlinerecognition",
            value: "orderHouseList"
          }
        ],
        toker: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_huokeneirong.png",
            name: "获客内容",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-share.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_xiaoshouxiansuo.png",
            name: "销售线索",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-track.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_fensishouzhong.png",
            name: "粉丝受众",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-fans.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_xiaoxitongzhi.png",
            name: "消息通知",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-notice.html"
          },
          {
            icon: "http://assets.rurushishi.com/yq-rs-desk/icon-live.png",
            name: "直播",
            type: "link",
            repository: "yq-rs-make",
            value: "live/myliveroom"
          }
        ],
        /**
         * 待分配客户放在第一个位置，然后为传播情况，
         * 传播情况即该项目所有粉丝受众的列表，
         * 然后为线索汇总，线索汇总即该项目所有的销售线索列表，
         * 第四为推广排行，即之前的推广排行，
         * 第五为kol列表
         */
        manage: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_daifenpeikehu.png",
            name: "待分配客户",
            type: "link",
            repository: "shqc-web",
            value: "user-stay-allot.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_shujuhuizong.png",
            name: "数据汇总", //传播情况,线索汇总,推广排行
            type: "link",
            repository: "yq-rs-wx",
            value: "rs/court-management"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_tuiguangpaihang.png",
            name: "推广排行",
            type: "link",
            repository: "shqc-web",
            value: "rs-desk-rank.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_zaixianrenchou.png",
            name: "在线认筹",
            type: "link",
            repository: "shqc-act&branch=wjAct&dir=onlinerecognition",
            value: "salePage"
          }
        ]
      },
      // 是否展示案场管理员菜单
      isShowSale2015MenuItems: false,
      // 中介 菜单
      agentMenuItems: {
        service: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodexiaoxi.png",
            name: "我的消息",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-notice.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodedingdan.png",
            name: "我的订单",
            type: "link",
            repository: "yq-act-web",
            value: ""
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_woderenchou.png",
            name: "我的认筹",
            type: "link",
            repository: "shqc-act&branch=wjAct&dir=onlinerecognition",
            value: "orderHouseList"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_yijianfankui.png",
            name: "意见反馈",
            type: "methods",
            repository: "",
            value: "clickYjfk"
          }
        ],
        toker: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_huokeneirong.png",
            name: "获客内容",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-share.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_xiaoshouxiansuo.png",
            name: "销售线索",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-track.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_fensishouzhong.png",
            name: "粉丝受众",
            type: "link",
            repository: "shqc-web",
            value: "rs-fmarket-fans.html"
          }
        ],
        manage: [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_tuijiankehu.png",
            name: "推荐客户",
            type: "link",
            repository: "shqc-web",
            value: "recommend-hr-zxslzx.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_guanlianxiaoshou.png",
            name: "关联销售",
            type: "link",
            repository: "shqc-web",
            value: "rs-relatedsale.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodekehu.png",
            name: "我的客户",
            type: "link",
            repository: "shqc-web",
            value: "fmarket-mycustomer-cqrc.html"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_zhanghumingxi.png",
            name: "账户明细",
            type: "link",
            repository: "shqc-web",
            value: "rs-desk-myaccount.html"
          }
        ]
      },
      // 是否展示中介菜单
      isShowAgentMenuItems: false,
      // lj22 是否展示我要推荐
      isShowMyRecommend: false,
      // 我要推荐 海报图 背景图片url
      myRecommendPosterBgUrl: "",
      // 我要推荐 海报图 二维码url
      myRecommendQrcodeUrl: "",
      // 我要推荐 海报图 url
      myRecommendPosterUrl: "",
      // 用户整体信息
      userIntegralInfo: null
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  methods: {
    afterRegisterHr() {
      this.isShowRegister = false;
      this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.slice(
        0,
        this.noSaleNoAgentMenuItems.length - 1
      );
      this.init().then(() => {
        // 注册后不用审批的时候
        if (this.registerStatusMsg == "") {
          if (this.$route.query.mycallback) {
            location.href = decodeURIComponent(this.$route.query.mycallback);
          }
        }
      });
    },
    afterRegisterVipcard() {
      this.isShowRegister = false;
      this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.slice(
        0,
        this.noSaleNoAgentMenuItems.length - 1
      );
      this.init();
    },
    clickMenu(item) {
      console.log(JSON.parse(JSON.stringify(item)));
      let initObj = Cookies.get("t9_20200131_init");
      if (initObj) {
        initObj = JSON.parse(initObj);
      }
      let url = "";
      if (
        item.type == "link" &&
        item.repository == "shqc-web" &&
        item.value &&
        initObj
      ) {
        url = `${location.protocol}//${location.host}/marketies/rc/${
          item.value
        }?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
        if (this.global.isLoc) {
          url = `http://localhost:2000/gong/yuanquan/shqc-web/marketies/rc/${
            item.value
          }?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
        }
        // 如果有传播者也一并把传播者传到打开的页面
        if (this.receiveSpreadInfo.refereeopenid) {
          url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
        }
        if (this.receiveSpreadInfo.rscuid) {
          url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
        }
        if (item.value == "rs-desk-rank.html") {
          url += "&from=person";
        }
        util.openUrl(url);
      } else if (
        item.type == "link" &&
        item.repository == "yq-rs-wx" &&
        item.value &&
        initObj
      ) {
        url = `${location.protocol}//${location.host}/marketies/rsrc/${
          item.value
        }?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
        if (this.global.isLoc) {
          url = `http://localhost:2001/marketies/rsrc/${
            item.value
          }?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
        }
        // 如果有传播者也一并把传播者传到打开的页面
        if (this.receiveSpreadInfo.refereeopenid) {
          url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
        }
        if (this.receiveSpreadInfo.rscuid) {
          url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
        }
        if (item.value == "rs/court-management") {
          url += `&pid=${this.pageInfo.Pid}`;
        }
        util.openUrl(url);
      } else if (
        item.type == "link" &&
        item.repository == "yq-act-web" &&
        initObj
      ) {
        //我的订单
        let appid = this.global.APPID;
        let openid = Cookies.get("openid");
        let backurl = `${location.protocol}//${location.host}/h5/t9_my?id=${
          initObj.id
        }&psn=${initObj.psn}`;
        // 如果有传播者也一并把传播者传到打开的页面
        if (this.receiveSpreadInfo.refereeopenid) {
          backurl += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
        }
        if (this.receiveSpreadInfo.rscuid) {
          backurl += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
        }
        let url = `${
          location.protocol
        }//${appid}.web.ruthyx.com/act/online/rs-h5-t9-coupon/rs-h5-t9-coupon.html#/coupon-list?o=${openid}&backurl=${encodeURIComponent(
          backurl
        )}`;
        util.openUrl(url);
      } else if (
        item.type == "link" &&
        item.repository == "shqc-act&branch=wjAct&dir=onlinerecognition"
      ) {
        // lj24 在线认筹 ，认筹订单
        util.openYqRsMakeLink(
          util.addUrlParamFromObj(
            `${location.protocol}//${location.host}/h5/t9_zxrc`,
            {
              from: "t9",
              page: item.value
            }
          )
        );
      } else if (item.type == "link" && item.repository == "yq-rs-make") {
        // 跳转本代码库其它页面
        util.openYqRsMakeLink(
          `${location.protocol}//${location.host}/h5/${item.value}`
        );
      } else if (item.type == "methods") {
        this[item.value]();
      } else {
        MessageBox.alert("敬请期待!");
      }
    },
    clickRegisterSale() {
      //判断是否华发
      if (util.checkIsHuafa()) {
        window.location.href = `${location.protocol}//${
          location.host
        }/marketies/rsrc/rs/register-vipcard?regfrom=deskperson`;
      }
      this.registerType = "sale";
      this.isShowRegister = true;
      Toast({
        message: "请填写下方表单注册！",
        duration: 3000
      });
    },
    clickRegisterAgent() {
      this.registerType = "agent";
      this.isShowRegister = true;
      Toast({
        message: "请填写下方表单注册！",
        duration: 3000
      });
    },
    // 销售名片
    //售楼中心测试id=136736&psn=30049651b3bb4e78a4be0cd0a82408c5&t9id=136553&t9psn=20c783740e214d929fe9c893c06bd0c0
    //中海定制id=177653&psn=f7826613e69643a7aec0428aa5b15ed4&entry=zxslzx&t9id=177645&t9psn=feb80466fdba4aa2a9ce67175161fed3
    clickInfo() {
      let url;
      if (location.host.indexOf("gyzhys.") > -1) {
        url = `${location.protocol}//${
          location.host
        }/h5/vcard3/home?saleropenid=${
          this.$openid
        }&id=177653&psn=f7826613e69643a7aec0428aa5b15ed4&entry=zxslzx&t9id=177645&t9psn=feb80466fdba4aa2a9ce67175161fed3`;
        window.location.href = url;
      } else {
        url = `${location.protocol}//${location.host}/h5/vcard2?saleropenid=${
          this.$openid
        }`;
        if (!this.isInMiniProgram || util.checkIsHaveOldMp()) {
          // 非小程序环境下加上back按钮
          url = util.addUrlParamFromObj(url, {
            backhome: "back"
          });
        }
        util.openYqRsMakeLink(url);
      }
    },
    clickYjfk() {
      this.$router.push("t9_suggest");
    },
    // 销售修改信息
    clickModify() {
      let url = `${this.isInMiniProgram ? "https" : "http"}://${
        location.host
      }/marketies/rc/rs-desk-modifyInfo.html`;
      url += `?entry=zxslzx&t9id=${this.receiveSpreadInfo.id}&t9psn=${
        this.receiveSpreadInfo.psn
      }`;
      // 如果有传播者也一并把传播者传到打开的页面
      if (this.receiveSpreadInfo.refereeopenid) {
        url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
      }
      if (this.receiveSpreadInfo.rscuid) {
        url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
      }
      util.openShqcWebLink(url);
    },
    /**
     * 点击按钮领取合伙人二维码
     * 普通用户 小程序下
     */
    clickGetMyRecommendPosterInMp() {
      if (this.myRecommendPosterUrl) {
        util.zxslzxNavigateToShareMomentsRespImageTxt(
          this,
          this.myRecommendPosterUrl
        );
      } else {
        this.createMyRecommendPosterForMp();
      }
    },
    // 生成神码图 小程序环境下
    createMyRecommendPosterForMp() {
      if (this.pageInfo.Extinfo && this.pageInfo.Extinfo.content_channel_tags) {
        comreq
          .getSmPicByTagAndQrtype(
            parseInt(this.pageInfo.Extinfo.content_channel_tags)
          )
          .then(data => {
            console.log("getSmPicByTagAndQrtype", data);
            if (
              data.code == 0 &&
              data.obj &&
              data.obj.pic_url &&
              data.obj.id &&
              data.obj.content
            ) {
              this.myRecommendPosterBgUrl =
                "http://assets.rurushishi.com/yq-rs-make/t9_zq/poster_bg.png";
              comreq
                .createUserPic(data.obj.id, data.obj.content)
                .then(data2 => {
                  console.log("createUserPic", data2);
                  if (data2.code == 0 && data2.obj && data2.obj.qrcode) {
                    comreq.base64(data2.obj.qrcode).then(data3 => {
                      this.myRecommendQrcodeUrl = data3;
                      this.$setLoading(true);
                      const sharpness = 2; //清晰度
                      let cvsImgData = [
                        {
                          type: "img",
                          shape: "", //默认是矩形，  'arc代表画圆'
                          zIndex: 2,
                          x: 0,
                          y: 0,
                          width: 1093 * sharpness,
                          height: 1468 * sharpness,
                          content: this.myRecommendPosterBgUrl
                        },
                        {
                          type: "img",
                          zIndex: 4,
                          x: ((1093 - 200) / 2) * sharpness,
                          y: (1468 - 200 - 100) * sharpness,
                          width: 200 * sharpness,
                          height: 200 * sharpness,
                          content: this.myRecommendQrcodeUrl
                        }
                      ];

                      const cvsimg = new Canvastoimg({
                        width: 1093 * sharpness, //画布宽度
                        height: 1468 * sharpness, //画布高度
                        color: "#ffffff", //画布背景色
                        data: cvsImgData
                      });

                      cvsimg.down().then(canvas => {
                        /* 获取到的是canvas对象 */
                        let posterUrl = canvas.toDataURL("image/jpg");
                        upload.uploadBase64ToOss(posterUrl).then(data => {
                          this.myRecommendPosterUrl = data;
                          // 因为二维码30分钟后会过期
                          setTimeout(() => {
                            this.myRecommendPosterUrl = "";
                          }, 1000 * 60 * 30);
                          util.zxslzxNavigateToShareMomentsRespImageTxt(
                            this,
                            this.myRecommendPosterUrl
                          );
                          this.$setLoading(false);
                        });
                      });
                    });
                  }
                });
            }
          });
      }
    },
    /**
     * 创建我的推荐海报图
     * 普通用户 H5环境下
     */
    createMyRecommendPosterForH5() {
      comreq
        .getSmPicByTagAndQrtype(
          parseInt(this.pageInfo.Extinfo.content_channel_tags)
        )
        .then(data => {
          console.log("我的推荐海报图中文字内容", data);
          if (
            data.code == 0 &&
            data.obj &&
            data.obj.pic_url &&
            data.obj.id &&
            data.obj.content
          ) {
            this.myRecommendPosterBgUrl =
              "http://assets.rurushishi.com/yq-rs-make/t9_my/poster_bg.png?x-oss-process=image/resize,p_80";
            comreq.createUserPic(data.obj.id, data.obj.content).then(data2 => {
              console.log("我的推荐海报图中二维码", data2);
              if (data2.code == 0 && data2.obj && data2.obj.qrcode) {
                comreq.base64(data2.obj.qrcode).then(data3 => {
                  this.myRecommendQrcodeUrl = data3;
                  this.$setLoading(true);
                  const sharpness = 2; //清晰度
                  let cvsImgData = [
                    {
                      type: "img",
                      shape: "", //默认是矩形，  'arc代表画圆'
                      zIndex: 2,
                      x: 0,
                      y: 0,
                      width: 1478 * sharpness,
                      height: 1630 * sharpness,
                      content: this.myRecommendPosterBgUrl
                    },
                    {
                      type: "img",
                      zIndex: 4,
                      x: ((1478 - 200) / 2) * sharpness,
                      y: (1630 - 200 - 160) * sharpness,
                      width: 200 * sharpness,
                      height: 200 * sharpness,
                      content: this.myRecommendQrcodeUrl
                    }
                  ];
                  const cvsimg = new Canvastoimg({
                    width: 1478 * sharpness, //画布宽度
                    height: 1630 * sharpness, //画布高度
                    color: "#ffffff", //画布背景色
                    data: cvsImgData
                  });

                  cvsimg.down().then(canvas => {
                    /* 获取到的是canvas对象 */
                    this.myRecommendPosterUrl = canvas.toDataURL("image/jpg");
                    this.$setLoading(false);
                  });
                });
              }
            });
          }
        });
    },
    /**
     * 初始化
     */
    init() {
      return new Promise((resolve, reject) => {
        util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
          // 是否注册过
          comreq.getUserIntegralInfo().then(userInfo => {
            this.userIntegralInfo = userInfo;
            console.log("用户完整信息", JSON.parse(JSON.stringify(userInfo)));
            // 测试数据开始
            if (this.global.isLoc) {
              // // 1、销售
              // userInfo.isSale = true;
              // userInfo.userInfo.role = [{ roleid: 2011 }];
              // // 2、案场管理人
              // userInfo.isSale = true;
              // userInfo.userInfo.role = [{ roleid: 2015 }];
              // // 3、中介
              // userInfo.isAgent = true;
              // userInfo.isSale = false;
              // // 4、非销售非中介
              // userInfo.isSale = false;
              // userInfo.isAgent = false;
              // // 附加状态
              // userInfo.saleStatusMsg = "审核中";
            }
            // 测试数据结束

            // 小程序环境下
            if (this.isInMiniProgram) {
              // 悦房云隐藏领取合伙人二维码
              if (this.global.SUBDOMAIN != "yuefangy") {
                this.isShowMyRecommend = true;
              }
            }
            /**
             * 角色判断
             */
            // 普通用户
            if (userInfo.isSale == false && userInfo.isAgent == false) {
              // 读取 我要推荐配置
              if (
                this.pageInfo.Extinfo &&
                this.pageInfo.Extinfo.open_recommend
              ) {
                this.isShowMyRecommend = true;
                // 需要展示 我要推荐
                if (this.isShowMyRecommend) {
                  // H5环境下
                  if (!this.isInMiniProgram) {
                    this.createMyRecommendPosterForH5();
                  }
                }
              }

              this.isShowNoSaleNoAgentMenuItems = true;
              this.isShowRegister = true;
              this.registerStatusMsg =
                userInfo.saleStatusMsg || userInfo.agentStatusMsg;
              if (this.registerStatusMsg == "") {
                // 注册销售
                if (this.$route.query.regtype == "sale") {
                  this.registerType = "sale";
                } else {
                  // 注册中介
                  this.registerType = "agent";
                }
              }

              // 定制
              // 泸州有好房隐藏注册全民经纪人
              if (
                this.global.SUBDOMAIN == "lzyh" ||
                util.checkIsHltcd() ||
                util.checkIsXbsjhcws() ||
                util.checkIsBcjszk()
              ) {
                this.isShowRegisterAgent = false;
              }
            } else if (userInfo.isSale == true) {
              //判断是否华发
              if (util.checkIsHuafa()) {
                window.location.href = `${location.protocol}//${
                  location.host
                }/marketies/rc/rs-desk-person.html?from=xsslzx`;
              }
              let is2015 = false;
              if (userInfo.userInfo.role && userInfo.userInfo.role.length > 0) {
                userInfo.userInfo.role.forEach(item => {
                  if (item.roleid == 2015) {
                    is2015 = true;
                  }
                });
              }
              if (is2015) {
                this.isShowSale2015MenuItems = true;
                this.registerStatusMsg = "案场管理人";
                if (
                  util.checkIsAlej() ||
                  location.host.indexOf("localhost") > -1 ||
                  location.host.indexOf("qmyx.") > -1
                ) {
                  this.sale2015MenuItems.manage.push({
                    icon:
                      "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodejinjiren.png",
                    name: "我的经纪人",
                    type: "link",
                    repository: "yq-rs-wx",
                    value: `rs/list-myagent`
                  });
                  this.sale2015MenuItems.manage.push({
                    icon:
                      "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_jinjirenzongbiao.png",
                    name: "经纪人总表",
                    type: "link",
                    repository: "yq-rs-wx",
                    value: `rs/list-agenttotal`
                  });
                }
              } else {
                this.isShowSale2011MenuItems = true;
                if (util.checkIsShlfsj()) {
                  this.registerStatusMsg = "招生老师";
                } else {
                  this.registerStatusMsg = "置业顾问";
                }
                if (
                  util.checkIsAlej() ||
                  location.host.indexOf("localhost") > -1 ||
                  location.host.indexOf("qmyx.") > -1
                ) {
                  this.sale2011MenuItems.manage.push({
                    icon:
                      "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodejinjiren.png",
                    name: "我的经纪人",
                    type: "link",
                    repository: "yq-rs-wx",
                    value: `rs/list-myagent`
                  });
                }
              }
            } else if (userInfo.isAgent == true) {
              this.isShowAgentMenuItems = true;
              if (
                util.checkIsAlej() ||
                location.host.indexOf("localhost") > -1 ||
                location.host.indexOf("qmyx.") > -1
              ) {
                this.agentMenuItems.manage.push({
                  icon:
                    "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_wodejinjiren.png",
                  name: "我的经纪人",
                  type: "link",
                  repository: "yq-rs-wx",
                  value: `rs/list-myagent?ftype=1`
                });
              }
            }
            resolve();
          });
        });
      });
    }
  },
  created() {
    this.init();
    // 润亿网络科技添加逾期报备---中介角色添加
    if (util.checkIsRunYiWangLuo()) {
      let yqbbItem = {
        icon:
          "http://assets.rurushishi.com/yq-rs-make/components/mine/icon_yuqibaobei.png",
        name: "逾期报备",
        type: "link",
        repository: "yq-rs-wx",
        value: "rs/overAudit"
      };
      this.agentMenuItems.manage.push(yqbbItem);
    }
    if (util.checkIsJwdc()) {
      this.agentMenuItems.manage = this.agentMenuItems.manage.filter(item => {
        return item.name != "关联销售";
      });
    }
    if (util.checkIsJydgsj()) {
      this.agentMenuItems.manage = this.agentMenuItems.manage.filter(item => {
        return item.name != "关联销售";
      });
    }
    if (util.checkIsShlfsj()) {
      this.agentMenuItems.manage = this.agentMenuItems.manage.map(item => {
        if (item.name == "关联销售") {
          item.name = "关联老师";
        }
        return item;
      });
      this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.filter(item => {
        return item.name != "我的认筹";
      });
      this.agentMenuItems.service = this.agentMenuItems.service.filter(item => {
        return item.name != "我的认筹";
      });
      this.sale2011MenuItems.service = this.sale2011MenuItems.service.filter(
        item => {
          return item.name != "我的认筹";
        }
      );
      this.sale2011MenuItems.manage = this.sale2011MenuItems.manage.filter(
        item => {
          return item.name != "预分配" && item.name != "在线认筹";
        }
      );
      this.sale2015MenuItems.manage = this.sale2015MenuItems.manage.filter(
        item => {
          return item.name != "在线认筹";
        }
      );
      this.sale2015MenuItems.service = this.sale2015MenuItems.service.filter(
        item => {
          return item.name != "我的认筹";
        }
      );
    }
    if (util.checkIsHsm()) {
      this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.filter(item => {
        return item.name != "我的认筹";
      });
      this.sale2011MenuItems.service = this.sale2011MenuItems.service.filter(
        item => {
          return item.name != "我的认筹";
        }
      );
      this.sale2011MenuItems.toker = this.sale2011MenuItems.toker.filter(
        item => {
          return item.name != "直播";
        }
      );
      this.sale2011MenuItems.manage = this.sale2011MenuItems.manage.filter(
        item => {
          return item.name != "在线认筹";
        }
      );

      this.sale2015MenuItems.service = this.sale2015MenuItems.service.filter(
        item => {
          return item.name != "我的认筹";
        }
      );
      this.sale2015MenuItems.toker = this.sale2015MenuItems.toker.filter(
        item => {
          return item.name != "直播";
        }
      );
      this.sale2015MenuItems.manage = this.sale2015MenuItems.manage.filter(
        item => {
          return item.name != "在线认筹";
        }
      );

      this.agentMenuItems.service = this.agentMenuItems.service.filter(item => {
        return item.name != "我的认筹";
      });
    }
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped>
p2r(designpx) {
  $rem = 49.33px;
  return (designpx / $rem) rem;
}

.mine {
  padding-bottom: 20px;
}

.ui {
  width: 100%;
  height: p2r(165px);
  background-image: url('http://assets.rurushishi.com/yq-rs-make/components/mine/ui_bg2.png'); // * background: linear-gradient(to right, #4CB8E9, #007DA6); *//* background: linear-gradient(to right, #f5af19, #f12711); *//* background: linear-gradient(to right, #4CB8E9, #007DA6); */
  display: flex;
  background-size: 100% 100%;
}

.ui_left {
  width: p2r(100px);
  height: p2r(165px - 46px);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ui_headline img {
  width: p2r(59px);
  height: p2r(59px);
  border-radius: 50%;
  border: 1px solid #fff;
}

.ui_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: left;
  height: p2r(165px - 46px);
}

.ui_right .no_reg {
  width: 3rem;
  position: relative;
}

.ui_right .no_reg .ui_name {
  font-size: 0.3rem;
  line-height: 0.4rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui_right .no_reg .ui_apply_status {
  font-size: 0.3rem;
  line-height: 0.4rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui_right .reg {
  width: 5rem;
  position: relative;
}

.ui_right .reg .ui_name {
  font-size: 0.3rem;
  line-height: 0.4rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui_right .reg .ui_apply_status {
  font-size: 0.3rem;
  line-height: 0.4rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui_right .reg .ui_op {
  position: absolute;
  top: p2r(5px);
  right: p2r(10px);
}

.ui_right .reg .ui_op > img {
  width: 25px;
  height: auto;
}

.ui_right .reg .ui_op > img:nth-child(2) {
  padding-left: 20px;
}

.ui_right .ui_reg_agent {
  position: absolute;
  top: 0.9rem;
  right: 0.4rem;
  font-size: 0.25rem;
  border: 1px solid #ffffff;
  height: 0.5rem;
  line-height: 0.5rem;
  padding: 0 0.2rem;
  display: inline-block;
  border-radius: p2r(5px);
  color: #fff;
}

.layer1 {
  border-top-left-radius: p2r(15px);
  border-top-right-radius: p2r(15px);
  margin-top: p2r(-46px);
  background-color: #fff;
}

.menu {
  display: flex;
  flex-wrap: wrap;
}

.menu_item {
  display: flex;
  width: 25%;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.menu_item > img {
  width: p2r(35px);
  height: p2r(35px);
  display: block;
  padding-top: p2r(10px);
}

.menu_item > div {
  width: 100%;
  color: #333333;
  margin-top: 10px;
  font-size: p2r(12px);
}

.area_title {
  width: 100%;
  height: 40px;
  padding: 5px 0;
  color: rgba(51, 51, 51, 1);
  background: #fff;
  text-align: left;
  font-size: p2r(16px);
  line-height: 40px;
  // border-bottom: 1px solid #ededed;
  border-top-left-radius: p2r(15px);
  border-top-right-radius: p2r(15px);
  font-weight: 500;
}

.area_title span {
  padding-left: 20px;
}

.cut_line {
  background: #f4f4f4;
  height: 5px;
  width: 100%;
  margin-top: 20px;
}

.btn1 {
  border: 1px solid #ef8532;
  color: #ef8532;
  width: 80%;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.5rem;
  font-size: 0.35rem;
  text-align: center;
  margin: 0.3rem auto;
}
</style>
